const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DataTrackingPopup/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        dialogTitle: 'Daten Tracking',
        dialogQuestion: 'Dürfen wir diese Daten erfassen?',
        dialogMessageDetail:
            'Wir freuen uns, dass Sie das Patientenportal unseres Spitals verwenden.\nDamit wir künftig den Bedürfnissen unserer Nutzerinnen und Nutzer noch gerechter werden und die App weiterentwickeln können, würden wir gerne Ihr Benutzerverhalten analysieren. Mit Ihrer Zustimmung helfen Sie uns, Patientinnen und Patienten während ihres Spitalaufenthalts noch besser begleiten zu können.',
        dialogAgree: 'Ja, ich bin damit einverstanden.',
        dialogDisagree: 'Nein, ich möchte das nicht.',
    },
    __RELATIVE_SOURCE_FILE__
);
